import ProductCard from "./ProductCard";
import "./ProductCardStyle.css";
import { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector, useDispatch } from "react-redux";
import { resetCategory } from "../redux/categorySlice";

export default function ProductsList() {
  const [lista, setLista] = useState([]);
  const category = useSelector((state) => {
    return state.category;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    const getLista = async () => {
      // console.log(process.env.REACT_APP_API_URL);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products`
      );
      setLista(response.data);
    };
    getLista();
  }, [category]);

  useEffect(() => {
    // console.log(category);
    return function () {
      dispatch(resetCategory());
      // console.log("clean");
    };
  }, []);

  return (
    lista && (
      <div className="container">
        <div className="border-list">
          <div
            id="productlist-div"
            className="d-flex flex-wrap justify-content-between"
          >
            {lista.map((producto, i) => {
              if (!category?.selected) {
                return (
                  <ProductCard
                    producto={producto}
                    name={producto.name}
                    price={producto.price}
                    img={producto.img}
                    slug={producto.slug}
                    key={i}
                  />
                );
              } else {
                if (producto.category === category?.selected) {
                  return (
                    <ProductCard
                      producto={producto}
                      name={producto.name}
                      price={producto.price}
                      img={producto.img}
                      slug={producto.slug}
                      key={i}
                    />
                  );
                }
              }
            })}
          </div>
        </div>
      </div>
    )
  );
}
